import Spin from 'antd/lib/spin';
import React, { Suspense, useContext } from 'react';
import { Route, RouterProvider, createHashRouter, createRoutesFromElements } from 'react-router-dom';

import { Authorization } from 'components/hoc/Authorization';
// Componenty
import { ErrorBoundaryComponent } from 'components/hoc/ErrorBoundaryComponent';
import PrivateRoute from 'components/hoc/PrivateRoute';
import { Context } from 'components/hoc/Store';
import NotFound from 'components/pages/NotFound';

// objekt s routama
import { routeMapa } from 'data/routeMapa';

import getLanguageObject from 'utils/getLanguageObject';

import DashboardWrapper from './DashboardWrapper';

const AppRouter: React.FC = () => {
    const { language } = useContext(Context);

    const router = createHashRouter(
        createRoutesFromElements(
            <Route element={<ErrorBoundaryComponent />}>
                <Route element={<Authorization />}>
                    <Route path={'*'} element={<NotFound />} />
                    <Route element={<DashboardWrapper />}>
                        {/* {routeMap()} */}
                        {routeMapa().map((route, index) => {
                            const RouteComponent = route.component;
                            // obalí komponenty 'kolečkem' při lazy loadingu - dokud se komponenta nenačte, "točí se kolečko"
                            const Component = (
                                <Suspense
                                    fallback={
                                        <div
                                            style={{
                                                padding: '15px',
                                                textAlign: 'center'
                                            }}
                                        >
                                            <Spin size="large" tip={getLanguageObject(language).NACITANI_APLIKACE} />
                                        </div>
                                    }
                                >
                                    <RouteComponent />
                                </Suspense>
                            );

                            return route.private ? (
                                <Route path={route.path} element={<PrivateRoute element={Component} />} key={index} />
                            ) : (
                                <Route path={route.path} element={Component} key={index} />
                            );
                        })}
                    </Route>
                </Route>
            </Route>
        )
    );

    return (
        <>
            <RouterProvider router={router} />
        </>
    );
};

export default AppRouter;
